import { AuthGuardGuard } from './modules/services/auth-guard';
import { ErrorPageComponent } from './modules/shared/error-page/error-page.component';
import { HomeDashboardComponent } from './modules/home/home-dashboard/home-dashboard.component';
import { LoginComponent } from './modules/login/login/login.component';
import { Routes } from '@angular/router';
import { SignUpComponent } from './modules/login/sign-up/sign-up.component';
import { UnauthorisedPageComponent } from './modules/shared/unauthorised-page/unauthorised-page.component';

export const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'home',
    component:HomeDashboardComponent,
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuardGuard]
  },
  {
    path: 'unauthorized',
    component: UnauthorisedPageComponent,
    canActivate: [AuthGuardGuard]
  },
  {
    path: 'no-record-found',
    component: ErrorPageComponent,
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];
